import React, { useCallback } from 'react';
import { SectionPanel } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { SecondaryTextMode, TranslationsComponent } from 'app/components/translation';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';

import { DashboardAdminTranslation } from '../../constants';
import { DashboardSectionType } from '../metroline/types';
import { languageValidationParameter, maxDescriptionLength } from '../constants';
import { DashboardItemValidation } from '../types-store';

interface DashboardLanguageProps extends WithMetroLineWrappedComponentProps<DashboardSectionType> {
  language: ComplexValue<number>[];
  mainLanguage: number;
  languageOptions: ComplexValue<number>[];

  changeLanguage: (languageId: number, text: string) => void;
  copyLanguageToAll: (languageId: number, successMessage: string) => void;

  showTranslations: boolean;
  switchTranslationsToggle: (value: boolean) => void;

  validation: DashboardItemValidation;
  translation: DashboardAdminTranslation;

  section: string;
}

export const DashboardLanguage: React.FC<DashboardLanguageProps> = ({
  language, mainLanguage, languageOptions,
  changeLanguage, copyLanguageToAll,
  showTranslations, switchTranslationsToggle,
  validation, translation,
  section, getRef, shouldRenderSection
}) => {
  const copyDescriptionToAll = useCallback(
    () => {
      copyLanguageToAll(mainLanguage, translation.copied_description_to_all);
    },
    [mainLanguage, translation]
  );

  return <MetroLineSection<DashboardSectionType>
    section={section}
    sectionType={DashboardSectionType.Translations}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(DashboardSectionType.Translations)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={DashboardSectionType.Translations}
        validation={undefined}
        info={{ text: translation.descriptions_and_translations }}
        label={{ visible: true, text: translation.descriptions_and_translations }} />
      <TranslationsComponent
        primaryText={language}
        secondaryText={undefined}
        primaryTextValueKey={languageValidationParameter}
        secondaryTextValueKey={undefined}
        primaryTextMaxLength={maxDescriptionLength}
        secondaryTextMaxLength={undefined}
        languageOptions={languageOptions}
        mainLanguage={mainLanguage}
        secondaryTextMode={SecondaryTextMode.disabled}
        readOnly={false}
        onPrimaryTextChange={changeLanguage}
        onSecondaryTextChange={undefined}
        copyPrimaryTextToAllTranslations={copyDescriptionToAll}
        copySecondaryTextToAllTranslations={undefined}
        hasTranslationsToggled={showTranslations}
        switchTranslationsToggle={switchTranslationsToggle}
        validation={validation?.language}
        primaryTextLabel={translation?.description}
        secondaryTextLabel={undefined}
        copyPrimaryTextToAllLabel={translation?.copy_description_to_all}
        copySecondaryTextToAllLabel={undefined}
        translationsHeaderLabel={translation?.translations_header}
        switchTranslationsToggleLabel={translation?.show_translations}
      />
    </div>
  </MetroLineSection>;
};
